export default __webpack_public_path__ + "static/media/template1.af907ce5.jpg";